<!-- ODV History Section -->
@if (salesOrderDocumentId) {
  <div>
    <!-- Header -->
    <div class="d-flex align-items-center form-title mt-4 mb-3" [ngClass]="isLight ? 'light' : 'dark'">
      <div class="d-flex align-items-center p-2">
        <img
          class="section-image"
          [src]="uploadablePeriodically ? '../../../../assets/icon/history.svg' : '../../../../assets/icon/article.svg'"
          [alt]="uploadablePeriodically ? 'history' : 'document'"
          />
      </div>
      <div class="form-title-text-container">
        <p class="my-0 py-0" [ngClass]="isLight ? 'light' : 'dark'">
          {{
          uploadablePeriodically ? ('ODV_HISTORY.TITLE' | translate) : ('ODV_HISTORY.NOT_PERIODIC_TITLE' | translate)
          }}
        </p>
      </div>
    </div>
    <!-- Loading State -->
    @if (isLoading) {
      <div class="loading-container text-center py-3">
        <div class="spinner-border spinner-border-sm text-primary" role="status">
          <span class="visually-hidden">{{ 'COMMON.LOADING' | translate }}</span>
        </div>
        <span class="ms-2">{{ 'COMMON.LOADING' | translate }}</span>
      </div>
    }
    <!-- History Items -->
    @if (!isLoading) {
      <div>
        @if (odvHistory$ | async; as history) {
          @if (history && history.length === 0) {
            <div class="text-muted text-center py-4">
              <app-icam-icon iconName="info-circle" iconColor="#666" />
              <p class="mt-2 mb-0">{{ 'ODV_HISTORY.NO_HISTORY' | translate }}</p>
            </div>
          }
          @for (item of history; track item) {
            <div class="file-downloader-container" [class.marked-for-removal]="isMarkedForRemoval(item)">
              <div class="info-section">
                <div class="info-item">
                  <span class="info-label" [ngClass]="isLight ? 'light' : 'dark'">{{
                    'ODV_HISTORY.DATE_LABEL' | translate
                  }}</span>
                  <span class="info-value" [ngClass]="isLight ? 'light' : 'dark'">{{ formatDate(item.createdDate) }}</span>
                </div>
              </div>
              <div class="info-section">
                <div class="info-item">
                  <span class="info-label" [ngClass]="isLight ? 'light' : 'dark'">{{
                    'ODV_HISTORY.FILE_LABEL' | translate
                  }}</span>
                  <span class="info-value" [ngClass]="isLight ? 'light' : 'dark'">{{
                    item.document?.fileName || ('ODV_HISTORY.DEFAULT_FILENAME' | translate)
                  }}</span>
                </div>
              </div>
              <div class="info-section">
                <div class="info-item">
                  <span class="info-label" [ngClass]="isLight ? 'light' : 'dark'">{{
                    'ODV_HISTORY.USER_LABEL' | translate
                  }}</span>
                  <span class="info-value" [ngClass]="isLight ? 'light' : 'dark'">{{
                    item.userName || ('COMMON.NO_USER' | translate)
                  }}</span>
                </div>
              </div>
              @if (isMarkedForRemoval(item)) {
                <span class="removal-hint">{{ 'ODV_HISTORY.CLEAR_PENDING' | translate }}</span>
              }
              @if (item.documentId && canClear) {
                <button
                  class="file-clear-button"
                  [ngClass]="isLight ? 'light' : 'dark'"
                  (click)="toggleRemoval(item)"
                  type="button"
                  [title]="'ODV_HISTORY.CLEAR_TOOLTIP' | translate"
                  >
                  {{ (isMarkedForRemoval(item) ? 'COMMON.CANCEL' : 'ODV_HISTORY.CLEAR') | translate }}
                </button>
              }
              @if (item.documentId) {
                <button
                  class="btn file-download-button"
                  [ngClass]="isLight ? 'light' : 'dark'"
                  (click)="downloadDocument(item.documentId!, item.document?.fileName)"
                  [disabled]="isDownloading"
                  type="button"
                  >
                  @if (!isDownloading) {
                    <span class="text-icam-danger fw-semibold">{{
                      'FILE_DOWNLOADER.DOWNLOAD' | translate
                    }}</span>
                  }
                  @if (isDownloading) {
                    <span class="text-muted fw-semibold">{{
                      'FILE_DOWNLOADER.DOWNLOADING' | translate
                    }}</span>
                  }
                </button>
              }
            </div>
          }
        } @else {
          <div class="text-muted text-center py-4">
            <app-icam-icon iconName="info-circle" iconColor="#666" />
            <p class="mt-2 mb-0">{{ 'ODV_HISTORY.NO_HISTORY' | translate }}</p>
          </div>
        }
      </div>
    }
  </div>
}
